import { Link } from "react-router-dom";
import { formatFullDate } from "../../../../../utils/date.utils";

const OrderInfo = ({ order, orderNo }) => {

    return (
        <>
            <div className="order-track-head">
                <h4>Order Details</h4>
                {order.invoice_url && (
                    <Link to={order.invoice_url} target="_blank">
                        <div style={{ padding: "10px", display: "flex", justifyContent: "space-between", fontSize:"13px" }}>
                        <div>
                        <span style={{ marginRight:"5px"}}>
                              View Bill
                        </span>
                        </div>
                        <div>
                            <i className="bi bi-download"></i>
                        </div>
                        </div>
                    </Link>
                )}
            </div>
            <hr />
            <div className="order-info">
                <p>Order Placed : {formatFullDate(order.order_placed_at)}</p>
                <p>Order ID : {orderNo}</p>
            </div>
        </>
    );
};

export default OrderInfo;